<template>
  <PfModal
    ref="modal"
    :has-changes="hasChanges"
    :is-slim="true"
    :locked-ids="[]"
    @after:close-animation="$emit('after:close-animation')"
  >
    <template #title>
      {{ $t('layout.dictation_mode_for_ipad') }}
    </template>

    <div
      class="com_modal__window-body"
    >
      <textarea
        ref="dictationTextarea"
        v-model="form.text"
        class="com_modal-dictation__textarea"
        :placeholder="$t('layout.dictation_placeholder')"
        :aria-label="$t('layout.dictation_placeholder')"
        data-testid="dictation-modal-textarea"
      />
    </div>

    <PfButtonBar
      class="com_modal__window-footer"
    >
      <PfButtonBarButton
        data-testid="dictation-modal-insert"
        @click="onClickInsert"
      >
        {{ $t('layout.dictation_insert') }}
      </PfButtonBarButton>

      <PfButtonBarLink
        data-testid="dictation-modal-cancel"
        @click="onClickCancel"
      >
        {{ $t('layout.cancel') }}
      </PfButtonBarLink>
    </PfButtonBar>
  </PfModal>
</template>

<script>
import PfButtonBar from '@/components/PfButtonBar.vue'
import PfButtonBarButton from '@/components/PfButtonBarButton.vue'
import PfButtonBarLink from '@/components/PfButtonBarLink.vue'
import PfModal from '@/components/PfModal.vue'

export default {
  name: 'ModalDictation',

  components: {
    PfModal,
    PfButtonBar,
    PfButtonBarButton,
    PfButtonBarLink,
  },

  emits: [
    'on:insert',
    'after:close-animation',
  ],

  data () {
    return {
      form: {
        text: '',
      },
    }
  },

  computed: {
    hasChanges () {
      return this.form.text.trim().length > 0
    },
  },

  mounted () {
    this.$nextTick(() => {
      this.$refs.dictationTextarea?.focus()
    })
  },

  methods: {
    onClickInsert () {
      if (this.form.text.trim()) {
        this.$emit('on:insert', this.form.text)
      }

      this.$refs.modal?.close()
    },

    onClickCancel () {
      this.$refs.modal?.close()
    },
  },
}
</script>

<style scoped>
.com_modal-dictation__textarea {
  width: 100%;
  min-height: 200px;
  padding: 10px;
  border: 1px solid var(--color-input-border);
  box-sizing: border-box;
  border-radius: var(--input-border-radius);
  resize: vertical;
  font-family: "Roboto Mono", monospace !important;
  font-size: inherit;
  line-height: inherit;
  outline: none;
  field-sizing: content;
  background-color: #fff;
  color: #000;
  color-scheme: light;
}

.com_modal-dictation__textarea:focus {
  border-color: var(--color-interactive);
}
</style>
